module.exports = __webpack_public_path__ + "static/media/sent-plane.3402a116.webp";